import React, { useState, useEffect } from 'react';
import { coaches } from '../api';
import './CoachSelector.css';

export default function CoachSelector({ onSelectCoach, onClose }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const searchCoaches = async () => {
      if (searchQuery.trim().length < 2) {
        setSuggestions([]);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // Fetch all coaches and filter by name
        const response = await coaches.getAllCoaches();
        const allCoaches = response.data.coaches || [];

        // Filter coaches by name (case-insensitive)
        const filtered = allCoaches.filter(coach => {
          const name = (coach.name || '').toLowerCase();
          const query = searchQuery.toLowerCase();
          return name.includes(query);
        });

        setSuggestions(filtered);
      } catch (err) {
        console.error('Error searching coaches:', err);
        setError('Failed to search coaches');
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    };

    // Debounce search
    const timer = setTimeout(searchCoaches, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  return (
    <div className="coach-selector-container">
      <div className="coach-selector-box">
        <div className="coach-selector-header">
          <h2>🎾 Select a Coach</h2>
          <button
            onClick={onClose}
            className="close-button"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="search-section">
          <input
            type="text"
            placeholder="Search coach by name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="coach-search-input"
            autoFocus
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="clear-button"
            >
              ✕
            </button>
          )}
        </div>

        {error && (
          <div className="error-message">
            ⚠️ {error}
          </div>
        )}

        <div className="suggestions-section">
          {loading && (
            <div className="loading-message">🔍 Searching...</div>
          )}

          {!loading && searchQuery.length < 2 && (
            <div className="placeholder-message">
              Start typing a coach's name...
            </div>
          )}

          {!loading && searchQuery.length >= 2 && suggestions.length === 0 && (
            <div className="no-results-message">
              No coaches found matching "{searchQuery}"
            </div>
          )}

          {!loading && suggestions.length > 0 && (
            <div className="suggestions-list">
              {suggestions.map(coach => (
                <button
                  key={coach._id}
                  onClick={() => onSelectCoach(coach._id)}
                  className="suggestion-item"
                >
                  <div className="coach-info">
                    <div className="coach-name">
                      {coach.name}
                    </div>
                    <div className="coach-role">
                      {coach.role === 'headcoach' ? '👑 Head Coach' : '🎾 Coach'}
                    </div>
                  </div>
                  <div className="selection-arrow">→</div>
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          onClick={onClose}
          className="back-button"
        >
          ← Back
        </button>
      </div>
    </div>
  );
}
